import calls from '@/backend/api-calls'

const state = () => ({
  locations: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    warehouse_id: null
  }
})

// getters
const getters = {
  ids: state => {
    return state.locations.map(d => d.id);
  }
}

// actions
const actions = {
  getLocations: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.warehouseLocations.get(parameters)
        .then(resp => {
          commit("setLocations", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addLocation({commit}, { data, parameters }) {
    return new Promise((resolve, reject) => {
      calls.warehouseLocations.post(data, parameters)
        .then(resp => {
          commit("insertLocation", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Warehouse location successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateLocation: ({commit}, { locationId, data }) => {
    return new Promise((resolve, reject) => {
      calls.warehouseLocation.put(locationId, data).then(
        resp => {
          commit("insertUpdatedLocation", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Location successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteLocation: ({commit}, locationId) => {
    return new Promise((resolve, reject) => {
      calls.warehouseLocation.delete(locationId).then(
        resp => {
          commit("removeLocation", locationId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Location successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setLocations(state, data) {
    state.pagination = data.pagination;
    state.locations = data.results;
  },
  insertLocation(state, data) {
    state.locations.push(data);
  },
  insertUpdatedLocation(state, data) {
    state.locations.forEach((location, i) => {
      if (location.id == data.id) {
        state.locations.splice(i, 1, data);
      }
    })
  },
  removeLocation(state,locationId) {
    state.locations.forEach((location, i) => {
      if (location.id == locationId) {
        state.locations.splice(i, 1);
      }
      const index = state.selected.indexOf(locationId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}